module.exports = __webpack_public_path__ + "static/media/vampire.c221526f.jpeg";